import { Eartefact } from './../../../others/eartefact';
import { Company } from '../../../register/organizational/company';
import { HospitalizationRegime, Performer } from 'cw-backend';
import { HospitalizationRegimeEditProvider } from '../../../../providers/tiss/hospitalization-regime/hospitalization-regime-edit.provider';
import { Insurance, CompanyCostCenter, Professional, Patient, ServiceCharacter, TypeHospitalization, AccidentIndicator } from 'cw-backend';
import { Moment } from 'moment';

export class Attachment {
    id: number;
    performer: Performer;
    insurance: Insurance;
    patient: Patient;
    eartefact: Eartefact[];
    name: string;
    dated: Moment;
    type: number;
}